var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.049,
    height: 25.1,
    viewBox: "0 0 19.049 25.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book",
    transform: "translate(-61.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(61.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M79.363,5.379h-.84V1.4a1.4,1.4,0,0,0-1.4-1.4H65.244a3.534,3.534,0,0,0-3.53,3.53V22.579A2.524,2.524,0,0,0,64.235,25.1H79.363a1.4,1.4,0,0,0,1.4-1.4V6.779A1.4,1.4,0,0,0,79.363,5.379Zm-14.119-3.7h11.6v3.7h-11.6a1.849,1.849,0,0,1,0-3.7ZM79.082,23.419H64.235a.841.841,0,0,1-.84-.84V6.536a3.507,3.507,0,0,0,1.849.524H79.082Z",
    transform: "translate(-61.714)",
    fill: "#f8333d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(66.42 13.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M166.538,283.429h-7.984a.84.84,0,0,0-.84.84v5.379a.84.84,0,0,0,.84.84h7.984a.84.84,0,0,0,.84-.84v-5.379A.84.84,0,0,0,166.538,283.429Zm-.84,5.379h-6.3v-3.7h6.3Z",
    transform: "translate(-157.714 -283.429)",
    fill: "#f8333d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(66.42 9.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M166.51,196.571h-7.956a.84.84,0,1,0,0,1.681h7.956a.84.84,0,1,0,0-1.681Z",
    transform: "translate(-157.714 -196.571)",
    fill: "#f8333d"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.a8ed6483142c24cac36774eb0c30f47f.svg";
export { ForwardRef as ReactComponent };